var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"JavaModelTitle"},[_c('div',{staticClass:"tit"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"subtit"},[_vm._v(_vm._s(_vm.subTitle))]),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.enTag.toUpperCase()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }